package kz.dentalcrm.app.navigation

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

internal class NavigationResultStore : NavigationResults {

    private val _results = MutableSharedFlow<NavigationResults.ResultEvent>(
        replay = 1,
        extraBufferCapacity = 64,
    )

    override val results = _results.asSharedFlow()

    override fun set(key: String, value: Any) {
        _results.tryEmit(NavigationResults.ResultEvent(key, value))
    }

    override fun clear(key: String) {
        _results.tryEmit(NavigationResults.ResultEvent(key, Unit))
    }
}
